<!--
 * @Author: xuquantong
 * @Date: 2022-04-29 11:30:40
 * @LastEditors: tianyuhan
 * @LastEditTime: 2023-07-25 21:02:27
 * @Description: 保障
-->
<template>
  <div
    v-if="guaranteeList"
    v-track="{
      act: 'show',
      params: {
        cfrom: '180|001|02|077',
        event_id: '180|001|02|077',
        page_name: 1,
        sku_id: skuId,
        is_new: 1
      }
    }"
  >
    <div class="guarantee-wrap" tabindex="0" @click="showGurant">
      <template v-if="isDark">
        <img src="./imgs/bz-bg-left_dark.png" alt="" class="i-left" />
        <img src="./imgs/bz-bg-center_dark.png" alt="" class="i-center" />
        <img src="./imgs/bz-bg-right_dark.png" alt="" class="i-right" />
      </template>
      <template v-else>
        <img src="./imgs/bz-bg-left.png" alt="" class="i-left" />
        <img src="./imgs/bz-bg-center.png" alt="" class="i-center" />
        <img src="./imgs/bz-bg-right.png" alt="" class="i-right" />
      </template>
      <div class="g-info" :aria-label="`官方保障${guaranteeList}`">{{ guaranteeList }}</div>
    </div>
    <v-os-popup
      container="body"
      v-model="isShowPop"
      class="guar"
      :title="title"
      @close="isShowPop = false"
      :footerShow="false"
    >
      <div class="guarantee-pop">
        <template v-for="(item, index) in quaranteePopList">
          <div class="g-item" :key="index" tabindex="0">
            <div v-if="index == 0" class="g-type">
              <p v-if="item.serviceType == 1">消费保障</p>
              <p v-else-if="item.serviceType == 2">官方承诺</p>
            </div>
            <div v-else class="g-type">
              <p v-if="item.serviceType == 1 && quaranteePopList[index - 1].serviceType != 1">消费保障</p>
              <p v-else-if="item.serviceType == 2 && quaranteePopList[index - 1].serviceType != 2">官方承诺</p>
            </div>
            <text-content :item="item" />
          </div>
        </template>
      </div>
    </v-os-popup>
  </div>
</template>

<script>
import { app } from '@/utils'
import { mapState, mapGetters } from 'vuex'
import TextContent from '../guarantee/text-content'

export default {
  name: 'GuaranteeNew',
  components: { TextContent },
  data() {
    return {
      isShowPop: false,
      isDark: app.getColorScheme() // 是否自定义深色模式
    }
  },
  computed: {
    ...mapState('detailv3', ['spuInfo']),
    ...mapGetters('detailv3', ['skuId']),
    title() {
      if (this.spuInfo?.officialServiceFlag) {
        return '官方保障'
      } else {
        return this.spuInfo.commoditySpu.proxySale === 1 ? '第三方商品售后保障' : '售后保障'
      }
    },
    guaranteeList() {
      const tips = this.spuInfo.commodityServiceTips || []
      if (tips.length == 1 && tips[0].serviceName == '正品保障') {
        return '正品保障'
      } else {
        return tips.flatMap(v => (v.serviceName !== '正品保障' ? [v.serviceName] : [])).join('·')
      }
    },
    quaranteePopList() {
      let list = Object.assign([], this.spuInfo.commodityServiceTips)
      // 按照分类排序
      return list.sort((a, b) => a.serviceType - b.serviceType)
    }
  },
  methods: {
    showGurant() {
      this.isShowPop = true
      this.$track({
        cfrom: '180|001|01|077',
        event_id: '180|001|01|077',
        page_name: 1,
        sku_id: this.skuId,
        is_new: 1
      })
    },
    format(val) {
      return val.replace(/\n|\r/g, '<br/>')
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
<style lang="scss" scoped>
.vivo-fontscale-5 {
  .g-info {
    top: 36px;
  }
}
</style>
<style lang="scss" scoped src="../../index/dark-popup.scss"></style>
